import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll to the top whenever the route (pathname) changes.
 *
 * React Router does not restore/reset scroll on navigation, so moving between
 * pages kept the previous scroll offset — landing the user partway down the new
 * page, below its header and primary "Add" action. This makes every screen open
 * from the top so the page is understood before scrolling.
 *
 * Keyed on `pathname` only — changing search params (pagination, filters) or the
 * hash does NOT scroll to top, so in-page list navigation stays put.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Instant (not smooth) so the new page is at the top before first paint.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
